import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import Select from 'lib/forms/select'

const UserSelect = ({ errors, user, users, onChange }) => (
  <div className={`form-element large ${errors.user ? 'has-errors' : ''}`}>
    <label className='block'>{I18n.t('pages.contact.user')}</label>
    <Select value={user} options={users} onValueChange={onChange} />
    {errors.user ? <div className='simple-error'>{errors.user}</div> : null}
  </div>
)

export default UserSelect

UserSelect.propTypes = {
  errors: PropTypes.object,
  onChange: PropTypes.func,
  user: PropTypes.string,
  users: PropTypes.array
}
